import PageProtectedLayout from "../../../../components/Page/PageProtectedLayout.jsx";
import GutMicrobiomeDashboard from "./GutMicrobiomeDashboard.jsx";
import { useTheme } from "@mui/material";
import { useTranslation } from "../../../../language.jsx";

export default function GutMicrobiomeWelcome() {

  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <PageProtectedLayout
      headline={t("gut_header")}
      specify={t("gut_header1")}
      headlineNoWrap
    >
      <GutMicrobiomeDashboard />
    </PageProtectedLayout>
  );
}